import UserIndex from '@/views/User/UserIndex.vue'
import UserLogin from '@/views/User/UserLogin.vue'
import UserResetPwd from '@/views/User/UserResetPwd.vue'
import UserForgetPwd from '@/views/User/UserForgetPwd.vue'
import UserAuth from '@/views/User/UserAuth.vue'
import UserImpersonate from '@/views/User/UserImpersonate.vue'
import UserInstallCallback from '@/views/User/UserInstallCallback.vue'

import LineNotifyCallBack from '@/views/Notify/LineNotifyCallBack.vue'
import TimerPubicIFrame from '@/views/OptimizePage/IframeTimer/TimerPubicIFrame.vue'
import PublicSubscription from '@/views/Setting/Subscription/PublicSubscription.vue'
import InvoiceCollectorPublicIframe from '@/views/OptimizePage/InvoiceCollector/PublicIframe.vue'
import FacebookLogin from '@/views/User/FacebookLogin.vue'

// import Home from '@/views/Home.vue'

const public_routes = [
  { path: '/', redirect: '/auth' },
  {
    name: '登入',
		path: '/',
    component: UserIndex,
    // component: () => import('@/views/User/UserIndex.vue'),
    children: [
      {
        path: "/login",
        name: "管理員登入",
        component: UserLogin,
        // component: () => import('@/views/User/UserLogin.vue'),
      },
      {
        path: "/reset_password",
        name: "重設密碼",
        component: UserResetPwd,
        // component: () => import('@/views/User/UserResetPwd.vue'),
      },
      {
        path: '/forget_password',
        name: "忘記密碼",
        component: UserForgetPwd
        // component: () => import('@/views/User/UserForgetPwd.vue'),
      },
      {
        path: '/auth',
        name: "登入",
        component: UserAuth
      },
      {
        name: "代客操作",
        path: '/user_impersonate',
        component: UserImpersonate
      },
      // {
      //   path: '/register',
      //   name: "註冊帳號",
      //   component: () => import('@/views/User/UserRegister.vue'),
      // }
    ]
  },
  {
    path: '/embed/timer',
    name: "倒數計時器",
    component: TimerPubicIFrame,
  },
  {
    path: '/embed/invoice_collector',
    name: "發票蒐集器",
    component: InvoiceCollectorPublicIframe,
  },
  {
    path: '/callback/line',
    name: 'Line Notify',
    component: LineNotifyCallBack
  },
  {
    path: '/subscription/plan',
    name: '訂閱方案',
    component: PublicSubscription
  },
  {
    path: '/facebook/connect',
    name: '臉書登入',
    component: FacebookLogin
  },
  {
    name: '登入',
		path: '/cyberbiz/plugin_auth',
    component: UserInstallCallback,
  },
  {
    path: '*',
    component: () => import('@/views/Error/NotFound.vue'),
    redirect: '/login',
    meta: {
        is_required_login: false,
    }
  },
  {
    name: '綁定 LINE 群組',
    path: '/bind-line-group',
    component: () => import('@/views/Setting/Container/BindLineGroup.vue'),
  },
  // {
  //   path: '/TreeView',
  //   component: () => import('@/views/Demo/TreeView.vue')
  // }
]

export {
    public_routes
}